import React from "react";
import Footer from "../Fotter";

const ShippingPolicy = () => {
  return (
    <div>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Shipping Policy</h1>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">Shipping Charges</h2>
          <ul className="list-disc pl-6">
            <li>Free Shipping: Orders above ₹2500.</li>
            <li>Prepaid Orders: ₹71 for orders below ₹2500.</li>
            <li>Cash on Delivery (COD): ₹71 per order.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">Handling Time</h2>
          <p>
            Orders are processed within <strong>1-3 business days</strong> after
            confirmation and payment verification. A tracking number will be
            sent via email upon dispatch.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">Transit Time</h2>
          <p>
            Delivery is estimated between <strong>1-7 business days</strong>,
            depending on the destination and order complexity.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">General Terms</h2>
          <ul className="list-disc pl-6">
            <li>
              Products are delivered across India. Unserviceable areas will be
              notified during order placement.
            </li>
            <li>
              Accurate shipping details (name, address, contact) are essential
              for timely delivery.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">
            Terms of Shipping and Delivery
          </h2>
          <ul className="list-disc pl-6">
            <li>
              We partner with third party logistic service providers in order to
              effectuate Product shipping and delivery to you (“Logistic
              Partners”). We shall provide the details of the Logistic Partner
              which will be responsible for processing the shipping and delivery
              of any Product(s) purchased by you on the fliptwirls Platform at
              the time such Product is processed and successfully handed over to
              the Logistic Partner by us. Our standard dispatch timelines
              depends on the pin code to which delivery is made. You can
              understand the estimated timelines on the ‘Product Detail Page’,
              once you enter the relevant delivery pin code. In any case the
              user will be provided with an estimated timeline for the delivery
              of the Product purchased from the fliptwirls Platform. This
              estimated timeline shall be notified to the user on the ‘Product
              Detail Page’, displayed at the time the order is confirmed by us.
              We will also share details about your orders pursuant to their
              dispatch on the e-mail ID and/or mobile number provided by you/
              registered with us. You agree and understand that though we
              effectuate Product delivery to the Users through our Logistic
              Partners, we reserve the right to ship and deliver the Products on
              our own without engaging any Logistic Partners or third party
              service providers.
            </li>
            <li>
              You agree and understand that though we endeavour to ship and
              deliver our Products all across India, we may, in our sole
              discretion determine a select list of areas which are
              unserviceable for delivery of Products. We or our Logistic
              Partners do not provide shipping and delivery services in such
              unserviceable areas and may not process your orders on the
              fliptwirls Platform in such cases. In the event an area has been
              deemed unserviceable by us, we shall notify such user at the time
              of placing an order on the fliptwirls Platform. You may also
              verify whether an area is unserviceable for deliveries by us by
              entering the relevant area pin-code on the fliptwirls Platform.
              fliptwirls reserves the right to cancel your order in case the
              Product is shipped and the pin-code becomes unserviceable.
            </li>
            <li>
              You agree and acknowledge that to effectuate timely delivery of
              the purchased Products to you, we may inquire or collect specific
              information like your name, shipping address, billing address,
              landmarks, contact details, etc. You shall ensure that all
              information that is submitted by you to us on the fliptwirls
              Platform is true, complete, accurate and sufficient to identify
              the actual place of delivery. You understand that, you shall bear
              absolute liability in case of any failure by us in delivering the
              purchased Products due to your failure to provide correct,
              complete, sufficient and accurate information at the time of
              placing the order. It is further clarified that we shall not be
              liable in any manner and at any point in time due to your failure
              to provide correct and complete information.
            </li>
            <li>
              We will attempt to deliver the purchased Product to your
              designated address within the estimated timeline of delivery
              notified to you. In the event you are not available or present to
              accept the delivery of the Product, our Logistic Partners will
              make a maximum of 2 (two) attempts to deliver the purchased
              Product(s) to you. If the second delivery attempt is unsuccessful
              and you continue to remain unavailable, we reserve the right to
              cancel the order of the purchased Products at our sole discretion
              and process the return of such Product to us. We further reserve
              the right to deduct the shipping and delivery charges borne by us
              while processing any refunds subsequent to such cancellation.
            </li>
            <li>
              We endeavour to engage Logistic Partners, employees, agents with
              the highest regard for ethics and integrity; and behave in a
              fashion that exudes thorough professionalism, competence and good
              mannerism. You agree and acknowledge that the actions, inactions
              of delivery individuals are not in our control, and it is not
              possible for us to monitor and observe each delivery executive.
              Since we are merely facilitating delivery of a Product purchased
              by you, we shall not be liable for any acts or omissions on part
              of our delivery agents, employees, or personnel and/ or the
              Logistic Partner or their employees, agents, or personnel
              including deficiency in service, wrong delivery of Product, time
              taken to deliver the Product, Product package tampering, etc. For
              the sake of abundant clarity, it is stated that any ill-mannerism,
              impoliteness, discourtesy or offensiveness shown by our delivery
              executives or the employees, agents, personnel of the Logistic
              Partners is beyond our control and any issue arising between you
              and our delivery executive or an employee, agent, personnel of the
              Logistic Partner will have to be resolved by the you,
              independently. You agree and acknowledge that you will not hold us
              responsible or require us to settle, mediate or resolve any
              disputes between you and the delivery personnel delivering the
              Products to you.
            </li>
            <li>
              Once you place an order on the fliptwirls Platform, we process
              such order and hand over the purchased Product to our Logistic
              Partner. The User will receive a unique tracking identity number
              once the purchased Product is handed over to the Logistics
              Partner, which will enable the User in tracking the status of
              delivery of the purchased Products. The User may use the tracking
              identity number on the fliptwirls Platform or the website and/or
              the mobile application of the Logistic Partner to check the status
              and location of the purchased Product and its estimated time of
              delivery. Our customer service team coordinates with the Logistic
              Partners to ensure that the Products are delivered to you at the
              earliest and make all reasonable efforts in ensuring that the
              Logistic Partners update the tracking status of the purchased
              Products on a real time basis. It is clarified that we engage
              third party service providers to effectuate deliveries of the
              Products and hence, we do not guarantee the accuracy or
              correctness of the tracking status and the status may be subject
              to inconsistencies arising out of time-lags in updating the
              information and/ or other technical difficulties which are not in
              our control.
            </li>
            <li>
              You will receive the Product after sharing One Time Password with
              our Logistic Partner. If the Product delivered to you comes
              along/together with its parts. You need to verify if all the parts
              are available in the package and make sure that the complete
              package as mentioned in the shipping box is being received by you.
            </li>
            <li>
              We reserve the right to charge or collect shipping fees on
              Products from time to time. Shipping charges may vary based on the
              value of the Product, type of Product, area of delivery, payment
              mechanism, etc. You agree that we are authorized to collect, on
              behalf of the Logistic Partner, the shipping and delivery fees for
              the delivery service provided by the Logistic Partner. In the
              event we charge a shipping fees for the delivery of a purchased
              Product, such shipping fees will not be refunded by us pursuant to
              any return request raised by you. However, we may make exceptions
              and refund the shipping fees in the event a defected, damaged,
              deficient or incorrect Product (for reasons attributable to, and
              accepted by us after due verification in our sole discretion) has
              been delivered. You acknowledge and accept that the title and risk
              of all Products ordered by you shall pass on to you upon the
              delivery of the purchased Products to you.
            </li>
            <li>
              Return of purchased Products are facilitated through our
              reverse-Logistics Partners. On receipt of request for return of
              Product on the fliptwirls Platform and the same being duly
              approved by us, our reverse-Logistics Partners shall get in touch
              with you in order to collect the purchased Products from you. We
              process returns and exchanges of purchased Products in accordance
              with our
              <a href="" className="text-blue-500 font-bold hover:underline">
                {" "}
                Cancellation and Return Policy.
              </a>
            </li>
          </ul>
        </section>
        <div className="mt-8 ">
          <h3 className="text-2xl font-medium text-gray-800">Contact Information</h3>
          <p className="text-lg text-gray-700 mt-2">
            <strong>Office and Warehouse Address:</strong>
          </p>
          {/* <p className="text-lg text-gray-700">Thakur Ji Ki Haweli Jalpa Mata Mandir Ke Pass Rajgarh, Rajgarh Madhya Pradesh, Bharat Pin 465661</p> */}
          <p className="text-lg text-gray-700 mt-2">Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001</p>
          <p className="text-lg text-gray-700 mt-2"><strong>Phone:</strong> +91 8047154521</p>
          <p className="text-lg text-gray-700 mt-2"><strong>Email:</strong> info@fliptwirls.com</p>
          <p className="text-lg text-gray-700 mt-2"><strong>Website:</strong> www.fliptwirls.com</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShippingPolicy;
